import { z } from "zod";

export const externalInvitationTokenQuerySchema = z.object({
	token: z.string().min(1),
});

export type ExternalInvitationTokenQuery = z.infer<typeof externalInvitationTokenQuerySchema>;
